export default "__VITE_ASSET__fd62f08f__"